"use client";

import { useEffect, useState } from "react";
import { BetaNotice } from "./beta-notice";
import { WebIocNotice } from "./webioc-notice";
import { BETA_NOTICE_STORAGE_KEY, WEBIOC_NOTICE_STORAGE_KEY } from "./onboarding-storage";

const WEBIOC_NOTICE_DELAY_MS = 320;

export function OnboardingNotices() {
    const [ready, setReady] = useState(false);
    const [betaSeen, setBetaSeen] = useState(true);
    const [showWebIoc, setShowWebIoc] = useState(false);

    useEffect(() => {
        if (typeof window === "undefined") {
            return;
        }

        const hasSeenBeta = window.localStorage.getItem(BETA_NOTICE_STORAGE_KEY);
        const hasSeenWebIoc = window.localStorage.getItem(WEBIOC_NOTICE_STORAGE_KEY);

        setBetaSeen(Boolean(hasSeenBeta));
        setShowWebIoc(Boolean(hasSeenBeta) && !hasSeenWebIoc);
        setReady(true);
    }, []);

    const openWebIocNotice = () => {
        if (typeof window === "undefined") {
            return;
        }

        if (window.localStorage.getItem(WEBIOC_NOTICE_STORAGE_KEY)) {
            return;
        }

        window.setTimeout(() => {
            setShowWebIoc(true);
        }, WEBIOC_NOTICE_DELAY_MS);
    };

    const handleBetaDismiss = () => {
        setBetaSeen(true);
        openWebIocNotice();
    };

    const handleWebIocDismiss = () => {
        setShowWebIoc(false);
    };

    if (!ready) {
        return null;
    }

    return (
        <>
            {!betaSeen ? <BetaNotice onDismiss={handleBetaDismiss} /> : null}
            {showWebIoc ? <WebIocNotice onDismiss={handleWebIocDismiss} /> : null}
        </>
    );
}
